import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { useForm, useWatch } from "react-hook-form";

import { validationSchema, useYupValidationResolver } from "./yupValidation";
import FormFields from "./formFields";
import { onSubmit } from "./submitForm";
import { useHistory } from "react-router";

const FormModal = ({
    open,
    handleClose,
    activeSelection,
    isRecurringPayment,
}) => {
    let history = useHistory();

    const resolver = useYupValidationResolver(validationSchema);
    const {
        handleSubmit,
        control,
        formState: { errors, isSubmitting },
    } = useForm({ resolver });

    const taxExemption = useWatch({
        control,
        name: "taxExemption", // without supply name will watch the entire form, or ['firstName', 'lastName'] to watch both
        defaultValue: false, // default value before the render
    });

    return (
        <Modal isOpen={open} toggle={handleClose} centered>
            <ModalHeader toggle={handleClose}>Personal Information</ModalHeader>
            <ModalBody>
                <form
                    onSubmit={handleSubmit((data) => onSubmit(data, history))}
                >
                    <FormFields
                        control={control}
                        errors={errors}
                        taxExemption={taxExemption}
                        isSubmitting={isSubmitting}
                        activeSelection={activeSelection}
                        isRecurringPayment={isRecurringPayment}
                    />
                </form>
            </ModalBody>
        </Modal>
    );
};

export default FormModal;
